var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moral !== undefined && _vm.moral !== null)?_c('font-awesome-icon',{staticClass:"text-muted mr-1",attrs:{"icon":['fal', _vm.moral ? 'building' : 'building-user']}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }